import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"

export const payrollRunSubmitV1Schema = z
  .object({
    runId: entityIdSchema,
    snapshotId: entityIdSchema,
  })
  .strict()

export const payrollSubmissionResultV1Schema = z
  .object({
    entityType: z.literal("payroll_run"),
    entityId: entityIdSchema,
    state: z.literal("Submitted"),
    version: z.number().int().positive(),
    snapshotId: entityIdSchema,
    snapshotRunVersion: z.number().int().positive(),
    inputCount: z.number().int().positive(),
    providerOperationId: z.string().min(1).max(128),
    providerCorrelationId: z.string().min(1).max(128).nullable(),
    sensitivePayloadPersisted: z.literal(false),
    exactlyOnce: z.literal(true),
  })
  .strict()

export type PayrollRunSubmitV1 = z.infer<typeof payrollRunSubmitV1Schema>
export type PayrollSubmissionResultV1 = z.infer<
  typeof payrollSubmissionResultV1Schema
>
